import { useState } from 'react';
import { Col, Row, Form,Input, Upload, Button, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { addCar } from '../redux/actions/carsActions';

function AddCar() {
    const dispatch = useDispatch();
    const [name, setname] = useState('');
    const [capacity, setcapacity] = useState('');
    const [fuelType, setfuelType] = useState('');
    const [rentPerHour, setrentPerHour] = useState('');

    const [images, setImages] = useState([]);
    const [imagesPreview, setImagesPreview] = useState([]);

    const normFile = (e) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    // const handleImageChange = (e) => {
    //     const files = Array.from(e.target.files);
    
    //     setImages([]);
    //     setImagesPreview([]);
    
    //     files.forEach((file) => {
    //         const reader = new FileReader();
    
    //         reader.onload = () => {
    //             if (reader.readyState === 2) {
    //                 setImagesPreview((old) => [...old, reader.result]);
    //                 setImages((old) => [...old, reader.result]);
    //             }
    //         };
    
    //         reader.readAsDataURL(file);
    //     });
    // };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        previewFile(file);
        setImages(e.target.files);
    };

    const previewFile = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setImagesPreview((old) => [...old, reader.result]);
            // setImages((old) => [...old, reader.result]);
        };
    };

    function onFinish(){
        let formData = new FormData();

        formData.append('name', name);
        formData.append('rentPerHour', rentPerHour);
        formData.append('capacity', capacity);
        formData.append('fuelType', fuelType);

        Array.from(images).forEach((image) => {
            formData.append('image', image);
        });
      
        formData.bookedTimeSlots = [];

        dispatch(addCar(formData));
    }

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
        console.log(file);
    };

    return (
        <Row justify="center mt-5" gutter={24}>
            <Col lg={20} sm={24} xs={24} className="p-2">
                <Form className="bs1 p-2" layout="vertical" onFinish={onFinish}>
                    <h3>Add New Car</h3>
                    <hr />
                    <Form.Item
                        name="name"
                        label="Car name"
                        value={name}
                        rules={[{ required: true }]}
                        onChange={(e) => {
                            setname(e.target.value);
                        }}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="rentPerHour"
                        label="Rent per hour"
                        value={rentPerHour}
                        rules={[{ required: true }]}
                        onChange={(e) => {
                            setrentPerHour(e.target.value);
                        }}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="capacity"
                        label="Capacity"
                        value={capacity}
                        rules={[{ required: true }]}
                        onChange={(e) => {
                            setcapacity(e.target.value);
                        }}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="fuelType"
                        label="Fuel Type"
                        value={fuelType}
                        rules={[{ required: true }]}
                        onChange={(e) => {
                            setfuelType(e.target.value);
                        }}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="image"
                        label="Car Image(s)"
                        type="image"
                        placeholder="browse files"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[{ required: true }]}
                        onChange={handleImageChange}
                        value={images}
                    >
                        <Upload
                            name="image"
                            customRequest={dummyRequest}
                            method="POST"
                            listType="picture"
                            multiple={true}
                            iconRender={() => {
                                return <Spin></Spin>;
                            }}>
                            <Button icon={<UploadOutlined />}>Click to upload Images</Button>
                        </Upload>

                    </Form.Item>

                    {imagesPreview.images?.map((image, index) => {
                        <img key={index} 
                            src={image.url}
                            alt="image preview"
                            style={{ height: '60px', margin: '5px' }}
                        />;
                    })}
                    
                    <div className="text-right">
                        <button className="btn1">ADD CAR</button>
                    </div>
                </Form>
            </Col>
        </Row>
    );
}

export default AddCar;
